<template lang="html">
  <div class="filter-bar" :class="more ? 'filter-bar-more' : ''">
    <v-row :size="2">
      <v-col :xs="12" :sm="12" :md="12" :lg="8">
        <v-input
          class="m-0"
          type="multiselect"
          v-model="filter.filterBarGeneral"
          :options="all_options"
          placeholder="Busca geral por tags. (Ex: desenvolvedor front-end angular bootstrap)"
        ></v-input>
      </v-col>
      <v-col :xs="12" :sm="12" :md="12" :lg="4">
        <v-input
          type="select"
          v-model="filter.filterBarProfile"
          :options="profilesName"
          placeholder="Perfil desejado"
        ></v-input>
      </v-col>
    </v-row>
    <v-div class="more" v-if="more">
      <v-divider line :size="3" />
      <v-row :size="2">
        <v-col :xs="12" :sm="12" :md="12" :lg="4">
          <v-input
            class="m-0"
            type="range"
            v-model="filter.filterBarHourValue"
            :min="20"
            :max="1000"
            tooltip="hover"
            :interval="20"
          >
            Valor da hora:
            <small
              >R${{ filter.filterBarHourValue[0] }} até R${{
                filter.filterBarHourValue[1]
              }}</small
            >
          </v-input>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="4">
          <v-input
            type="select"
            v-model="filter.filterBarFocus"
            :options="focusName"
            placeholder="Foco de atuação"
          ></v-input>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="4">
          <v-input
            type="number"
            v-model="filter.filterVibbranteCode"
            placeholder="Código do profissional"
            helptext="Para aplicar quando houverem indicações da Vibbra"
          ></v-input>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="8">
          <v-input
            type="multiselect"
            v-model="filter.filterBarSkills"
            :options="skillsName"
            placeholder="Habilidades específicas"
          ></v-input>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="4">
          <v-input
            type="select"
            v-model="filter.filterBarType"
            :options="typesName"
            placeholder="Tipo de profissional"
          ></v-input>
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="6">
          <v-input
            type="range"
            v-model="filter.filterBarHoursWork"
            tooltip="hover"
            :interval="5"
            :min="0"
            :max="50"
            >Horas disponíveis por semana:
            <small
              >{{ filter.filterBarHoursWork[0] }}h até
              {{ filter.filterBarHoursWork[1] }}h</small
            ></v-input
          >
        </v-col>
        <v-col :xs="12" :sm="12" :md="12" :lg="6">
          <v-input
            type="range"
            v-model="filter.filterBarXP"
            tooltip="hover"
            :min="0"
            :max="50"
            >Experiência:
            <small
              >{{ filter.filterBarXP[0] }} anos até
              {{ filter.filterBarXP[1] }} anos</small
            ></v-input
          >
        </v-col>
      </v-row>
    </v-div>
    <v-divider line :size="2" />
    <v-div class="filter-bar-actions">
      <v-button class="primary" :size="2" @click="search()">
        <v-icon name="v-find" class="mr-2" /> Filtrar
      </v-button>
      <span class="filter-bar-actions-links">
        <v-button v-if="more" :size="2" @click.native="more = !more"
          ><v-icon name="arrow-up" class="mr-2" /> Fechar opções
          avançadas</v-button
        >
        <v-button v-else :size="2" @click.native="more = !more"
          ><v-icon name="arrow-down" class="mr-2" /> Opções avançadas</v-button
        >
        <v-button :size="2" @click="clearAllFilters()">Limpar tudo</v-button>
      </span>
    </v-div>
  </div>
</template>

<script>
import clientApi from '@/api/client';

export default {
  props: {
    alloption: {},
    profile: '',
    focus: '',
    type: '',
  },
  data() {
    return {
      more: false,
      filter: {
        page: 1,
        filterBarGeneral: [],
        filterBarSkills: [],
        filterBarProfile: this.profile,
        filterBarType: this.type,
        filterBarFocus: this.focus,
        filterBarHourValue: [20, 1000],
        filterBarHoursWork: [0, 50],
        filterBarXP: [0, 50],
        filterVibbranteCode: null,
      },
      skills: [],
      roles: [],
      types: [],
      tags: [],
      all_options: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    clearAllFilters() {
      this.filter = {
        page: 1,
        filterBarGeneral: [],
        filterBarSkills: [],
        filterBarProfile: '',
        filterBarType: '',
        filterBarFocus: '',
        filterBarHourValue: [20, 1000],
        filterBarHoursWork: [0, 50],
        filterBarXP: [0, 50],
      };
    },
    fetchData() {
      clientApi
        .clientSearchOptions()
        .then(response => {
          if (response.status === 200) {
            this.skills = response.data.skills;
            this.roles = response.data.roles;
            this.types = response.data.types;
            this.tags = response.data.tags;
            this.all_options = response.data.all_options;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    search() {
      this.$emit('handleSearchClick', this.filter);
    },
  },
  computed: {
    skillsName() {
      const names = [];
      this.skills.forEach(element => {
        names.push(element.name);
      });
      return names;
    },
    allOptions() {
      const names = [];
      this.skills.forEach(element => {
        names.push(element.name);
      });
      this.roles.forEach(element => {
        names.push(element.name);
        element.focus.forEach(foco => {
          names.push(foco);
        });
      });
      this.types.forEach(element => {
        names.push(element.name);
        element.types.forEach(tipo => {
          names.push(tipo);
        });
      });
      this.tags.forEach(element => {
        names.push(element);
      });
      return names;
    },
    profilesName() {
      const names = [];
      this.roles.forEach(element => {
        names.push(element.name);
      });
      return names;
    },
    typesName() {
      const names = [];
      this.types.forEach(element => {
        names.push(element.name);
      });
      return names;
    },
    focusName() {
      const names = [];
      this.roles.forEach(element => {
        element.focus.forEach(foco => {
          if (
            element.name === this.filter.filterBarProfile ||
            this.filter.filterBarProfile === ''
          ) {
            names.push(foco);
          }
        });
      });
      return names;
    },
  },
};
</script>

<style lang="scss">
.filter-bar {
  .form-group {
    .form-label {
      color: gray;
      margin: 0;

      span {
        color: black;
      }
    }
    .form-range {
      // padding: 8px 0!important;
    }
  }
  .filter-bar-actions {
    display: flex;
    flex-direction: column;

    .filter-bar-actions-links {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
    }
  }

  @include media-breakpoint-up(md) {
    .filter-bar-actions {
      flex-direction: row;

      .filter-bar-actions-links {
        flex-direction: row;
        margin-top: 0;
        margin-left: auto;
        .button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/filter-bar.vue